(function () {
  function isLeatReady() {
    return !!(
      window.LeatSDK &&
      window.LeatSDK.api &&
      typeof window.LeatSDK.api.getCurrentCustomer === 'function'
    );
  }

  function waitForLeatSDK(callback) {
    if (isLeatReady()) {
      callback();
      return;
    }
    var attempts = 0;
    var maxAttempts = 100; // ~20s at 200ms
    var timer = setInterval(function () {
      attempts++;
      if (isLeatReady()) {
        clearInterval(timer);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 200);
  }

  function renderCustomerInfo(root) {
    var pointsRoot = root.querySelector('[data-kgrh-points]');
    var walletLink = root.querySelector('[data-kgrh-wallet]');
    if (!pointsRoot && !walletLink) return;

    LeatSDK.api.getCurrentCustomer()
      .then(function (customer) {
        if (!customer) return;

        if (pointsRoot && customer.points) {
          var valueEl = pointsRoot.querySelector('[data-kgrh-points-value]');
          if (valueEl) valueEl.textContent = customer.points.current;
          pointsRoot.hidden = false;
        }

        if (walletLink && customer.addToWalletUrl) {
          walletLink.href = customer.addToWalletUrl;
          walletLink.hidden = false;
        }
      })
      .catch(function (error) {
        console.error('KG Rewards Hero: could not load customer info from Leat', error);
      });
  }

  document.querySelectorAll('.kgrh-hero').forEach(function (root) {
    waitForLeatSDK(function () {
      renderCustomerInfo(root);
    });
  });
})();
